// extracted by mini-css-extract-plugin
module.exports = {"skuDetail":"Products_skuDetail__2QnzF","wrapper":"Products_wrapper__E-yq_","sub":"Products_sub__3o-Zb"};